import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import {
    AllFaqsModule,
    ClaimNumberHeaderModule,
    ClaimSummaryModule,
    SharedModule as ClaimsTrackerSharedModule,
    CloseAccordionModule,
    ContactToggleModule,
    ContactUsModule,
    InteractiveFaqsModule,
    MemberTimelineModule,
    PayoutAccordionModule,
    RepairsAccordionModule,
    ReportAccordionModule,
    ServicesAccordionModule
} from '@nationwide/claims-component-library';
import { BreadCrumbsComponent } from '@nationwide/internet-servicing-angular-components';
import { NationwideComponentsModule } from 'app/common/nationwide-components.module';
import { FindRepairShopModule } from 'app/findRepairShop/find-repair-shop.module';
import { ClaimsTrackerGuard } from 'app/route_guards/claims-tracker.guard';
import { AccessGuard } from 'app/route_guards/router-access.guard';
import { ClaimTrackerAuto } from './claim-tracker-auto.component';
import { FaqComponent } from './faq/faq.component';
import { OysTrackerShopConfirmComponent } from './oys-tracker-shop-confirm/oys-tracker-shop-confirm.component';
import { OysTrackerShopSelectComponent } from './oys-tracker-shop-select/oys-tracker-shop-select.component';
import { VehicleLocationAddressFormComponent } from './vehicle-location-address-form/vehicle-location-address-form.component';

const routes: Routes = [
    {
        path: '',
        component: ClaimTrackerAuto,
        canActivate: [ClaimsTrackerGuard, AccessGuard],
        data: { title: 'Track Your Claim' }
    },
    {
        path: 'all-faq/:category',
        component: FaqComponent,
        canActivate: [AccessGuard],
        data: { title: 'All FAQ' }
    },
    {
        path: 'oys-shop-select',
        component: OysTrackerShopSelectComponent,
        canActivate: [AccessGuard],
        data: { title: 'Find a Repair Shop' }
    },
    {
        path: 'oys-shop-confirm',
        component: OysTrackerShopConfirmComponent,
        canActivate: [AccessGuard],
        data: { title: 'Confirm Repair Shop' }
    }
];

@NgModule({
    declarations: [ClaimTrackerAuto, FaqComponent, OysTrackerShopSelectComponent, OysTrackerShopConfirmComponent, VehicleLocationAddressFormComponent],

    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        BreadCrumbsComponent,
        ClaimsTrackerSharedModule,
        PayoutAccordionModule,
        InteractiveFaqsModule,
        RepairsAccordionModule,
        ReportAccordionModule,
        ServicesAccordionModule,
        ContactToggleModule,
        CloseAccordionModule,
        ClaimSummaryModule,
        MemberTimelineModule,
        ClaimNumberHeaderModule,
        ContactUsModule,
        AllFaqsModule,
        FindRepairShopModule,
        ReactiveFormsModule,
        CommonModule,
        NationwideComponentsModule,
        RouterModule.forChild(routes)
    ]
})
export class ClaimTrackerAutoModule {}
